const CLASE_LABELS = {
  deposito: 'Depósito',
  extraccion: 'Extracción',
  transferencia_cuenta: 'Transferencia entre cuentas',
  transferencia_caja: 'Transferencia entre cajas',
  cheque_tercero: 'Cheque de tercero',
};

const CLASE_TITULOS = {
  deposito: 'Depósito de fondos',
  extraccion: 'Extracción de fondos',
  transferencia_cuenta: 'Transferencia entre cuentas',
  transferencia_caja: 'Transferencia entre cajas',
  cheque_tercero: 'Depósito de cheque de tercero',
};

const CLASE_SUBTITULOS = {
  deposito: 'Ingreso de efectivo o cheques de terceros a una cuenta bancaria.',
  extraccion: 'Retiro desde cuenta bancaria hacia una o más cajas.',
  transferencia_cuenta: 'Movimiento de fondos entre dos cuentas bancarias.',
  transferencia_caja: 'Movimiento de efectivo entre dos cajas.',
  cheque_tercero: 'Depósito de un cheque de tercero en cuenta bancaria.',
};

export function etiquetaClaseFondo(clase, tipo) {
  if (clase && CLASE_LABELS[clase]) return CLASE_LABELS[clase];
  if (tipo === 'ingreso') return 'Ingreso';
  if (tipo === 'egreso') return 'Egreso';
  return tipo || '-';
}

export function tituloMovimientoFondos(clase, tipoFondos) {
  if (clase && CLASE_TITULOS[clase]) return CLASE_TITULOS[clase];
  if (tipoFondos === 'ingreso') return CLASE_TITULOS.deposito;
  if (tipoFondos === 'egreso') return CLASE_TITULOS.extraccion;
  return 'Movimiento de fondos';
}

export function subtituloMovimientoFondos(clase, tipoFondos) {
  if (clase && CLASE_SUBTITULOS[clase]) return CLASE_SUBTITULOS[clase];
  if (tipoFondos === 'ingreso') return CLASE_SUBTITULOS.deposito;
  if (tipoFondos === 'egreso') return CLASE_SUBTITULOS.extraccion;
  return 'Registro de movimiento de cajas o cuentas bancarias.';
}

/** Texto unificado origen → destino (API enriquecida o fallback local). */
export function textoOrigenDestino(mf) {
  if (mf?.origen_label && mf?.destino_label) {
    return `${mf.origen_label} → ${mf.destino_label}`;
  }
  const cuenta = mf?.numero_cuenta || mf?.banco_nombre
    ? `${mf.banco_nombre || ''} ${mf.numero_cuenta || ''}`.trim()
    : null;
  if (cuenta) return cuenta;
  const det = mf?.detalles || [];
  if (det.length === 1 && det[0].caja_nombre) return `Caja ${det[0].caja_nombre}`;
  if (det.length > 0) {
    const nombres = det
      .filter((d) => d.tipo === 'caja' && d.caja_nombre)
      .map((d) => d.caja_nombre);
    if (nombres.length) return nombres.join(', ');
  }
  return mf?.caja_origen_nombre || mf?.caja_destino_nombre || '—';
}
